/**
 * CORE-1479 (возврат QA 23.10) — какие вызовы AddReaction / RemoveReaction
 * нужны, чтобы нажатие по реакции `type` сделало то, что человек видит.
 *
 * Снять — все свои слаги той же картинки, каким бы слагом они ни стояли
 * (`ownReactionSlugs`). Чип ладони рисует и прежнюю `love`, и раньше снятие
 * уходило слагом комплекта: сервер не находил строки, своя старая реакция
 * оставалась, а следующее нажатие у закрытой награды упиралось в замок.
 *
 * Поставить — одна реакция от человека на сообщение: сначала сняты все прежние
 * свои, потом поставлена новая. Вызовы выполняются по порядку, по одному:
 * пара, отправленная разом, может лечь снятием последним и стереть только что
 * поставленную.
 *
 * Без React и сети — общая для веба (`useChatThreadSource`) и натива
 * (`screens/messages/useChatThread`), проверяется в jest.
 */
import { ownReactionSlugs } from '../../constants/brandReactions';

export interface ReactionCall {
  type: string;
  add: boolean;
}

export function myReactionCalls(mine: readonly string[], type: string, add: boolean): ReactionCall[] {
  if (!add) {
    const own = ownReactionSlugs(mine, type);
    // Своей не нашлось — расклад разошёлся с сервером; снимаем то, что просили.
    return (own.length ? own : [type]).map((slug) => ({ type: slug, add: false }));
  }
  return [
    ...mine.filter((slug) => slug !== type).map((slug) => ({ type: slug, add: false })),
    { type, add: true },
  ];
}
